// extracted by mini-css-extract-plugin
export default {"editedUserDitails":"settingsModals_editedUserDitails__P0oXB"};